export default {
  Nome: '',
  userName: '',
  access_token: '',
  refresh_token: '',
  expires_in: '',
  expires: ''
}
